module.exports = __webpack_public_path__ + "static/media/ccBack.d0240d3e.png";